export default __webpack_public_path__ + "static/media/Women_fr.7c512051.svg";